module.exports = __webpack_public_path__ + "img/Autocolant TCHE_55mm x 60mm-01.17631f50.jpg";